import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedFunctions } from '.../../../src/app/shared/shared.functions';
import { HttpErrorResponse } from '@angular/common/http';

import { Comunidad, MenuFuncionCodes, SearchComunidadRequest } from '../../../../../../src/app/shared/model';
import { ComunidadService, MenuFuncionService, MovimientoService } from '../../../../../../src/app/shared/services';

@Component({
  selector: 'app-jobsMovimientoSegundoVencimiento',
  templateUrl: './jobsMovimientoSegundoVencimiento.component.html',
  styleUrls: ['./jobsMovimientoSegundoVencimiento.component.scss']
})

export class JobsMovimientoSegundoVencimientoComponent implements OnInit {

  canView: boolean = false;

  isComunidadSearching: boolean = false;
  isValidating: boolean = false;
  isRunning: boolean = false;

  comunidadList: Comunidad[];

  formGroup: FormGroup;

  constructor(
    private sharedFunctions: SharedFunctions,
    private service: MovimientoService,
    private formBuilder: FormBuilder,
    private menuService: MenuFuncionService,
    private comunidadService: ComunidadService
  ) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.JOBS_MOVIMIENTO_SEGUNDO_VENCIMIENTO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        this.canView = true;
        this.loadView();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  loadView() {
    this.buildForm();
    this.getComunidades();
  }

  buildForm() {
    var fechaHoy = new Date();
    var fechaMes1 = new Date(fechaHoy.getFullYear(), fechaHoy.getMonth(), 1);
    var fechaMes2 = new Date(fechaHoy.getFullYear(), fechaHoy.getMonth() + 1, 1);

    this.formGroup = this.formBuilder.group({
      'FechaInicialControl': [fechaMes1],
      'FechaFinalControl': [fechaMes2],
      'FechaVencimientoControl': [fechaHoy],
      'ComunidadId': [null]
    });
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null)
        this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  runJob() {
    var search = {
      ...this.formGroup.value
    };

    this.isRunning = true;
    this.service.runJobSegundoVencimiento(search).subscribe(data => {
      this.isRunning = false;
      if (data.Success) {
        this.sharedFunctions.showMessage("Se actualizaron " + data.Result.TotalActualizado + " movimientos de un total de " + data.Result.TotalProcesados, "Operación Exitosa!");
      }
      else
        this.sharedFunctions.showMessage("Ocurrió un error ejecutando el proceso", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isRunning = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}
